export const PropertyConfidentialNegotiation = {
    OPEN: false,
    RESERVED: true,
}
